import { useEffect } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useBreadcrumbs } from '../../../components/ui/breadcrumps/breadcrumbsContext';
import InstanceHistoryTimeline from '../../../components/ui/instanceHistoryTimeline/instanceHistoryTimeline.component';
import { DetailPage } from '../../../components/ui/detailView';

export const ContractHistory = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { setOverride, clearOverride } = useBreadcrumbs();

  useEffect(() => {
    if (!id) {
      return undefined;
    }

    const historyPath = `/contracts/${id}/history`;
    setOverride(historyPath, t('Contract History'));

    return () => {
      clearOverride(historyPath);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, t]);

  return (
    <DetailPage>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        {t('Contract History')}
      </Typography>
      {id && (
        <InstanceHistoryTimeline
          modelName="contract"
          objectId={id}
          refreshEventName="contractUpdated"
        />
      )}
    </DetailPage>
  );
};
